var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosedticket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.75,
    width: 38.5,
    height: 38.5,
    rx: 19.25,
    fill: "#FCFCFC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.75,
    width: 38.5,
    height: 38.5,
    rx: 19.25,
    stroke: "#FF4444",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_24888)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9892 14.3472L23.3354 20.001L28.9892 25.6548L28.2436 26.4008L18.6797 20.001L28.2436 13.6016L28.9892 14.3472Z",
    fill: "#E0230D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2426 13.6025L21.8427 20.0019L28.2426 26.4017L25.9057 28.7382L20.2519 23.0844L14.5981 28.7382L11.5156 25.6557L17.1694 20.0019L11.5156 14.3481L14.5981 11.2656L20.2519 16.9194L25.9057 11.2656L28.2426 13.6025Z",
    fill: "#FF5440"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_24888"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(11.25 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedticket);
export default __webpack_public_path__ + "static/media/closedticket.e4842873ec5e509184f1482eb4fb027f.svg";
export { ForwardRef as ReactComponent };